import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import TextField from '@mui/material/TextField';

export default function RHFTextField({ name, helperText, type, ...other }) {
  const { control, trigger } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          fullWidth
          type={type}
          value={field?.value ?? ''}
          onChange={(event) => {
            const nextValue = event.target.value;
            field.onChange(nextValue);
          }}
          onBlur={(event) => {
            if (typeof field.value === 'string') {
              field.onChange(field.value.trim());
            }
            field.onBlur();
            // Skip when focus moves to a submit button: submit validates anyway, and an error
            // appearing here shifts the layout mid-click so the button click gets lost.
            if (event.relatedTarget?.type !== 'submit') {
              trigger(name);
            }
          }}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}

RHFTextField.propTypes = {
  helperText: PropTypes.node,
  name: PropTypes.string,
  type: PropTypes.string,
};
